import * as React from 'react';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';

function TwoColumnsTextSection({ title, text, ctaText, ctaLink, ctaTextTwo, ctaLinkTwo }: any) {
    const isBreakpoint = useMediaQuery(MediaQueryWidth['desktop-md']);

    return (
        <div
            className={`wrapper black flex v-center  h-center moves-for-good ${
                ctaLink ? 'ready-to-join' : 'yellow-bg'
            }`}
        >
            <div className="content flex">
                <div
                    className="w-1/3 md:w-1/1 flex column h-center"
                    style={{
                        flexGrow: 1,
                        width: '370px',
                        maxWidth: '80vw',
                    }}
                >
                    <div
                        className="black weight-black moves-for-good-h1 beehive-h1"
                        dangerouslySetInnerHTML={{ __html: title }}
                    />
                </div>
                {isBreakpoint ? (
                    <div
                        className="w-1/3 md:w-1/1 flex column h-center"
                        style={{
                            flexGrow: 1,
                            maxWidth: '610px',
                        }}
                    >
                        <p
                            className="black"
                            style={{ lineHeight: 1.4 }}
                            dangerouslySetInnerHTML={{ __html: text }}
                        />

                        {ctaLink ? (
                            <>
                                <div className="faq-ctas flex h-center">
                                    <a
                                        className="weight-bold"
                                        href={ctaLink}
                                        title={ctaText}
                                        aria-label={ctaText}
                                    >
                                        {ctaText}
                                    </a>
                                </div>
                                {ctaLinkTwo ? (
                                    <div className="faq-ctas flex h-center">
                                        <a
                                            className="weight-bold"
                                            href={ctaLinkTwo}
                                            title={ctaTextTwo}
                                            aria-label={ctaTextTwo}
                                        >
                                            {ctaTextTwo}
                                        </a>
                                    </div>
                                ) : null}
                            </>
                        ) : null}
                    </div>
                ) : (
                    <div
                        className="w-1/3 md:w-1/1 flex column h-center"
                        style={{
                            flexGrow: 1,
                            maxWidth: '610px',
                        }}
                    >
                        <p
                            className="black"
                            style={{ lineHeight: 1.4 }}
                            dangerouslySetInnerHTML={{ __html: text }}
                        />

                        {ctaLink ? (
                            <>
                                <div className="faq-ctas flex h-center">
                                    <a
                                        className="weight-bold"
                                        href={ctaLink}
                                        title={ctaText}
                                        aria-label={ctaText}
                                    >
                                        {ctaText}
                                    </a>

                                    {ctaLinkTwo ? (
                                        <a
                                            className="weight-bold"
                                            href={ctaLinkTwo}
                                            title={ctaTextTwo}
                                            aria-label={ctaTextTwo}
                                        >
                                            {ctaTextTwo}
                                        </a>
                                    ) : null}
                                </div>
                            </>
                        ) : null}
                    </div>
                )}
            </div>
        </div>
    );
}

export { TwoColumnsTextSection };
